import { useRouter } from 'next/router'
import { useMemo, type PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { PageTitleProvider as SharedPageTitleProvider } from '@omnea-app/fe-legacy/components/layout/page-metadata/PageTitleContext'
import { buildRouteTitleMap, getTitleFromMap } from './routeTitleMap'

export const PageTitleProvider = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation('route-titles')
  const routeTitleMap = useMemo(() => buildRouteTitleMap(t), [t])
  const router = useRouter()
  const baseTitle = getTitleFromMap(router.asPath, routeTitleMap) || 'Omnea'

  return <SharedPageTitleProvider baseTitle={baseTitle}>{children}</SharedPageTitleProvider>
}
